import Scrollable from "./Scrollable"
import { GetPeersByEoaResponse } from "../swarm.apiv1"
import { For, Show } from "solid-js"
import LoadingSpinner from "./LoadingSpinner"
import ErrorMessage from "./ErrorMessage"
type PeerTableProps = {
	data: GetPeersByEoaResponse | undefined | null
	loading: boolean
	error?: Error | null
	theme: "normal" | "inverted"
}

const twoDecimalPlaces = (value: number) => {
	return value.toFixed(2)
}

// TODO: This component is intended to be re-useable as a peer table and the leaderboard table.
// There's more massaging required to make it work for both cases, but this is a starting point.
export default function PeerTable(props: PeerTableProps) {
	let containerRef: HTMLDivElement | undefined
	const classes = {
		"bg-info-content text-info": props.theme === "inverted",
		"bg-info text-info-content": props.theme === "normal",
	}
	return (
		<Scrollable class="max-h-[270px] min-h-[150px] border-2 border-dotted border-base-200" classList={classes}>
			<div ref={containerRef}>
				<table data-testid="peer-table" class="min-w-full table-auto border-collapse border-dotted border-separate border-spacing-1 border-spacing-x-0 py-1 px-4 border-base-200">
					<thead>
						<tr class="align-top">
							<th class="font-normal text-left w-[4em] relative">
								Rank
								<THSeparator theme={props.theme} />
							</th>
							<th class="font-normal text-left w-auto relative">
								Name
								<THSeparator theme={props.theme} />
							</th>
							<th class="font-normal text-left w-auto relative">
								Participation
								<THSeparator theme={props.theme} />
							</th>
							<th class="font-normal text-left w-auto relative">
								Training&nbsp;Rewards
								<THSeparator theme={props.theme} />
							</th>
						</tr>
					</thead>
					<tbody class="uppercase">
						<Show when={props.loading && (!props.data || props.data.peers.length === 0)}>
							<tr>
								<td colspan="4" class="text-center" data-testid="loading-spinner">
									<LoadingSpinner message="Loading..." />
								</td>
							</tr>
						</Show>
						<Show when={!props.loading && (!props.data || props.data.peers.length === 0)}>
							<tr>
								<td colspan="4" class="text-center" data-testid="no-peers">
									No nodes found
								</td>
							</tr>
						</Show>
						<Show when={props.error}>
							<tr>
								<td colspan="4" class="text-center" data-testid="error-message">
									<ErrorMessage message={props.error?.message || "Error loading your nodes"} />
								</td>
							</tr>
						</Show>
						<For each={props.data?.peers}>
							{(entry, index) => (
								<tr data-testid={`peer-row-${index()}`}>
									<td data-testid="peer-rank" class="font-normal text-left w-auto relative">
										{entry.rank || ">100"}
									</td>
									<td data-testid="peer-name" class="font-normal text-left w-auto relative">
										{entry.name}
									</td>
									<td data-testid="peer-participation" class="font-normal text-left w-auto relative">
										{entry.participation}
									</td>
									<td data-testid="peer-reward" class="font-normal text-left w-auto relative">
										{twoDecimalPlaces(entry.reward)}
									</td>
								</tr>
							)}
						</For>
					</tbody>
				</table>
			</div>
		</Scrollable>
	)
}

type THSeparatorProps = {
	theme: "normal" | "inverted"
}

function THSeparator(props: THSeparatorProps) {
	const classes = {
		"border-primary": props.theme === "inverted",
	}
	return <span classList={classes} class="absolute bottom-0 left-0 w-[90%] border-b border-dotted"></span>
}
